export default "__VITE_ASSET__D6Ms$Sv4__"